import type { SpecialType } from '@iheartjane/types';

import { api } from '../api';
import type {
  FetchStoreSpecialsProps,
  StoreSpecialsResponse,
} from './storeSpecials.types';

const BASE_URL = '/v3/stores';

const storeSpecialsUrls = {
  storeSpecials: (storeId: string | number) =>
    `${BASE_URL}/${storeId}/specials`,
};

const appendSpecialTypeParams = (
  params: URLSearchParams,
  specialType?: SpecialType | SpecialType[]
) => {
  if (!specialType) return;

  const types = Array.isArray(specialType) ? specialType : [specialType];
  types.forEach((type) => params.append('special_type[]', type));
};

export const fetchStoreSpecials = async ({
  appMode,
  includeHidden,
  page,
  perPage,
  specialType,
  storeId,
}: FetchStoreSpecialsProps) => {
  const params = new URLSearchParams();

  if (page !== undefined) {
    params.set('page', `${page}`);
  }

  if (perPage !== undefined) {
    params.set('per_page', `${perPage}`);
  }

  params.set('app_mode', appMode);

  if (includeHidden !== undefined) {
    params.set('include_hidden', `${includeHidden}`);
  }

  appendSpecialTypeParams(params, specialType);

  const query = params.toString();
  const url = `${storeSpecialsUrls.storeSpecials(storeId)}${query ? `?${query}` : ''}`;

  return api.get<StoreSpecialsResponse>(url);
};
